import { _ as t } from "../internals/export.js";
import { f as a } from "../internals/function-apply.js";
import { a as n } from "../internals/a-callable.js";
import { a as r } from "../internals/an-object.js";
import { f as o } from "../internals/fails.js";
t({
  target: "Reflect",
  stat: !0,
  forced: !o(function () {
    Reflect.apply(function () {});
  })
}, {
  apply: function apply(t, o, s) {
    return a(n(t), o, r(s));
  }
});